module.exports = __webpack_public_path__ + "media/images/logo--white-59b914e2424e56fd79f302a9fc99eb7e.svg";